import styled from "styled-components";

export const ImageDownloadErrorWrapper = styled.div`
  width: ${(p) => p.$width || 120}px;
  height: ${(p) => p.$height || 120}px;
  background: #eef1f1;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px;
  box-sizing: border-box;
  gap: 4px;
  flex-shrink: 0;
`;

export const ImageDownloadErrorContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 4px;
  font-size: 11px;
  color: #6f7171;
`;

export const ImageDownloadErrorRefresh = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
`;
